(function() {
  'use strict';

  function openTabbyPopup(url) {
    const modal = document.createElement('div');
    modal.className = 'tabby-popup-modal';

    let closeIconUrl = '';
    const baseUrl = window.location.origin;

    const existingCloseIcon = document.querySelector(
      'img[src*="icon_close.svg"], img[src*="icon-close.svg"], img[src*="close-pop.svg"], img[src*="c_close_medium.svg"]'
    );

    if (existingCloseIcon && existingCloseIcon.src) {
      closeIconUrl = existingCloseIcon.src;
    } else {
      closeIconUrl = `${baseUrl}/assets/icon_close.svg`;
    }

    const overlay = document.createElement('div');
    overlay.className = 'tabby-popup-overlay';

    const container = document.createElement('div');
    container.className = 'tabby-popup-container';

    const closeButton = document.createElement('button');
    closeButton.className = 'tabby-popup-close';
    closeButton.setAttribute('aria-label', 'Close');
    closeButton.type = 'button';

    const closeIcon = document.createElement('img');
    closeIcon.src = closeIconUrl;
    closeIcon.alt = 'Close';
    closeIcon.width = 10;
    closeIcon.height = 10;
    closeIcon.className = 'tabby-popup-close-icon';
    closeButton.appendChild(closeIcon);

    const iframeWrapper = document.createElement('div');
    iframeWrapper.className = 'tabby-popup-iframe-wrapper';

    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.className = 'tabby-popup-iframe';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('scrolling', 'no');

    iframeWrapper.appendChild(iframe);
    container.appendChild(closeButton);
    container.appendChild(iframeWrapper);
    modal.appendChild(overlay);
    modal.appendChild(container);

    document.body.appendChild(modal);

    window.themeScrollLock?.lock?.();

    container.style.overflowY = 'auto';
    container.style.overflowX = 'hidden';
    container.style.pointerEvents = 'auto';
    container.style.webkitOverflowScrolling = 'touch';

    const isMobile = window.innerWidth < 750;
    if (isMobile) {
      container.style.maxHeight = '100dvh';
    }

    iframe.style.pointerEvents = 'auto';
    iframe.style.touchAction = 'manipulation';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      modal.classList.add('is-open');
    } else {
      void modal.offsetWidth;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          modal.classList.add('is-open');
        });
      });
    }

    let closing = false;
    const closeModal = () => {
      if (closing) return;
      closing = true;
      modal.classList.remove('is-open');
      document.removeEventListener('keydown', handleEsc);

      const removeModal = () => {
        if (document.body.contains(modal)) {
          document.body.removeChild(modal);
        }
        window.themeScrollLock?.unlock?.();
      };

      if (reduceMotion) {
        removeModal();
        return;
      }

      setTimeout(removeModal, 480);
    };

    overlay.addEventListener('click', closeModal);

    const handleClose = (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      closeModal();
      return false;
    };

    closeButton.addEventListener('click', handleClose, { passive: false });
    closeButton.addEventListener('touchend', handleClose, { passive: false });
    closeButton.addEventListener('touchstart', (e) => {
      e.stopPropagation();
    }, { passive: false });

    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', handleEsc);
      }
    };

    document.addEventListener('keydown', handleEsc);
  }

  window.openTabbyPopup = openTabbyPopup;
})();
